export default function fileType(filename) {
  if (filename) {
    var parts = filename.split('.');
    return (parts = parts[parts.length - 1]);
  }
  return 'png';
}
